import { theme as sharedTheme } from '@bottlebooks/gatsby-shared';
import { theme as baseTheme } from '@bottlebooks/gatsby-theme-base';
import filter from '../components/Filters/filterFieldVariants';
import quickLink from '../components/LandingPage/quickLinkVariants';

const theme = {
  ...baseTheme,
  ...sharedTheme,
  shadows: {
    ...baseTheme.shadows,
    primary: `0 0 0 1px ${baseTheme.colors?.primary}`,
    secondary: `0 0 0 1px ${baseTheme.colors?.secondary}`,
    accent: `0 0 0 1px ${baseTheme.colors?.accent}`,
    border: `0 0 0 1px ${baseTheme.colors?.border}`,
    borderSecondary: `0 0 0 1px ${baseTheme.colors?.borderSecondary}`,
    borderNuanced: `0 0 0 1px ${baseTheme.colors?.borderNuanced}`,
    light: `0 0 0 1px ${baseTheme.colors?.light}`,
    background: `0 0 0 1px ${baseTheme.colors?.background}`,
  },

  // # Component variants
  filter,
  quickLink,
};

export default theme;
